// Locale for the document renderer.
//
// `MarkdownView` is called from a dozen places (reader, overlay, diff, staff
// console, emails view) and NONE of them passes `t`; threading a translator
// through every call site to give a tooltip its "Zkopírovat" label would be a
// change to every caller for one leaf. The renderer instead reads the locale
// the app already decided, and `App` pushes it on every locale change.
//
// The default is Czech and the read never touches localStorage during render:
// the fixtures and tests render with `renderToStaticMarkup` in a Node
// environment where there is no window at all.
import type { Locale } from "../../shared/dto";
import { translate } from "../i18n";

let current: Locale = "cs";

export function setDocLocale(locale: Locale): void {
  current = locale;
}

export function docLocale(): Locale {
  return current;
}

/**
 * Translate for renderer-owned chrome (copy buttons, tooltip affordances,
 * timeline labels). Missing keys are a build error in `check:locales`, so a
 * throw here would only turn a caught mistake into a blank document; the key
 * itself is returned instead and stands out immediately when looked at.
 */
export function docT(key: string): string {
  try {
    return translate(current, key);
  } catch {
    return key;
  }
}
